import { AppStateType } from 'reducers';
import { Selector } from 'react-redux';
import { RequestStatusState } from 'RequestStatusModule/reducers';

export const selectRequestStatusState: Selector<AppStateType, RequestStatusState> = (state) =>
  state.requestStatusReducer;
